import React, { useState, useRef, useEffect } from "react";
import "./MobileOtpVerification.css";
import { useDispatch } from "react-redux";
import { setActiveComponent } from "../../../Redux/Slices/activeComponentSlice";
import Cookies from "js-cookie";
import { signupWithPhoneNumber } from "../../../api/auth";
import { useNavigate } from "react-router-dom";
import { setAuthTokens } from "../../../api";
import { setUserDetails } from "../../../Redux/Slices/userDetailsSlice";

function MobileOtpVerification() {
  const [timer, setTimer] = useState(120);
  const [canResend, setCanResend] = useState(false);
  const [otpError, setOtpError] = useState(false);

  const navigate = useNavigate();
  // Snackbar state
  const [snackbar, setSnackbar] = useState({
    show: false,
    message: "",
    type: "info" 
  });
  const length = 6;
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputRefs = useRef([]);
  const dispatch = useDispatch();
  const countryCode = localStorage.getItem("countryCode");
  const phoneNumber = localStorage.getItem("phoneNumber");

  // Snackbar helper function
  const showSnackbar = (message, type = "info") => {
    setSnackbar({ show: true, message, type });
    setTimeout(() => {
      setSnackbar({ show: false, message: "", type: "info" });
    }, 3000);
  };

  const handleChange = (element, index) => {
    setOtpError(false);
    const value = element.value.replace(/\D/, "");
    if (!value) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    // Auto focus next
    if (index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const updatedOtp = [...otp];
      updatedOtp[index] = "";
      setOtp(updatedOtp);

      // Focus previous
      if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text").slice(0, length);
    const updatedOtp = [...otp];
    paste.split("").forEach((char, i) => {
      if (i < length) {
        updatedOtp[i] = char;
        inputRefs.current[i].value = char;
      }
    });
    setOtp(updatedOtp);
  };

  // const handleOtpContinueClick = async () => {
  //   const enteredOtp = otp.join("");
  //   console.log("enteredOtp", enteredOtp);
  //   if (!enteredOtp || enteredOtp.length < 6) {
  //     showSnackbar("Please enter the full OTP", "error");
  //     setOtpError(true);
  //     return;
  //   }
  
  //   try {
  //     const countryCode = localStorage.getItem("countryCode");
  //     const phoneNumber = localStorage.getItem("phoneNumber");

  //     console.log("countryCode & phoneNumber", countryCode, phoneNumber);

  //     const result = await signupWithPhoneNumber(countryCode, phoneNumber, enteredOtp);
  
  //     if (result?.success && result?.statusCode === 200) {
  //       console.log("Signup Success:", result);
  
  //       // success action
  //       dispatch(setActiveComponent("ballot"));
  //       navigate("/ballots");
  //     } else {
  //       showSnackbar(result?.message || "Invalid OTP", "error");
  //     }
  //   } catch (error) {
  //     showSnackbar(error?.response?.data?.message || "Signup Failed", "error");
  //   }
  // };
  

  const handleSignupWithPhoneNumber = async () => {
    const enteredOtp = otp.join("");
    if (!enteredOtp || enteredOtp.length < 6) {
      showSnackbar("Please enter the full OTP", "error");
      setOtpError(true);
      return;
    }
  
    try {
      const countryCode = localStorage.getItem("countryCode");
      const phoneNumber = localStorage.getItem("phoneNumber"); 
  
      console.log("countryCode & phoneNumber", countryCode, phoneNumber);
      console.log("enteredOtp", enteredOtp);
  
      const refreeAffiliateCode = localStorage.getItem("refreeAffiliateCode") || undefined;
      const result = await signupWithPhoneNumber(countryCode, phoneNumber, enteredOtp, refreeAffiliateCode);

      if (result?.success && result?.statusCode === 200) {
        console.log("Signup Success:", result);
        
        // Clear phone number data from localStorage after successful signup
        localStorage.removeItem("countryCode");
        localStorage.removeItem("phoneNumber");
        localStorage.setItem("userId", result.data.userDetails.userId);
        
        // Use the centralized setAuthTokens function for consistent token management
        setAuthTokens(result.data);
        dispatch(setUserDetails(result.data.userDetails));
        
        console.log("Phone signup - Tokens set:", { 
          token: !!result.data.token, 
          refreshToken: !!result.data.refreshToken,
          userId: !!result.data.userDetails.userId 
        });
        
        // Navigate to signup success component
        dispatch(setActiveComponent("signUpSuccessfull"));
      } else {
        showSnackbar(result?.message || "Invalid OTP", "error");
      }
    } catch (error) {
      showSnackbar(error?.response?.data?.message || "Signup Failed", "error");
      console.log("error", error);
    }
  };
  
  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(countdown);
    } else {
      setCanResend(true);
    }
  }, [timer]);

  const handleResend = () => {
    setTimer(120); 
    setCanResend(false);
    showSnackbar("OTP has been resent successfully!", "success");
  };

  return (
    <div className="OtpVerification">
      <div className="otpVerificationContainer">
        <span className="getStartedText">Verification</span>
        <span className="signInText2">
          Enter your 6 digits code that you received on your
        </span>
        <span className="signInText2">
          {phoneNumber?.length >= 4
            ? phoneNumber.slice(0, 2) +
              "*".repeat(phoneNumber.length - 4) +
              phoneNumber.slice(-2)
            : phoneNumber}
        </span>
        <div className="enterMobileOtpContainer">
          <span className="labelText">Phone Verification Code</span>
          <div className="otpInputContainer" onPaste={handlePaste}>
            {otp.map((digit, i) => (
              <input
                key={i}
                type="text"
                maxLength="1"
                className={otpError ? "otpInputFalse" : "otpInputTrue"}
                value={otp[i]}
                onChange={(e) => handleChange(e.target, i)}
                onKeyDown={(e) => handleKeyDown(e, i)}
                ref={(el) => (inputRefs.current[i] = el)}
              />
            ))}
          </div>
        </div>
        <span className="forgetMobilePasswordTimer">
          {Math.floor(timer / 60).toString().padStart(2, "0")}:{(timer % 60).toString().padStart(2, "0")}
        </span>
        <button
          className="btnContainer"
          onClick={handleSignupWithPhoneNumber}
          style={{ marginTop: "2vh" }}
        >
          <span className="btnText">Continue</span>
        </button>
        <span className="resendMobileCodeContainer">
          Didn't receive a code!{" "}
          <button
            className={`resendBtn-${canResend ? "active" : "disabled"}`}
            onClick={handleResend}
            disabled={!canResend}
          >
            Resend
          </button>
        </span>
      </div>
      
      {/* Snackbar */}
      {snackbar.show && (
        <div className={`snackbar snackbar-${snackbar.type}`}>
          <span className="snackbar-message">{snackbar.message}</span>
        </div>
      )}
    </div>
  );
}

export default MobileOtpVerification;
